import { z } from 'zod';
import { phoneSchema, safeTextSchema } from '@petseo/shared';
import { pl } from '@/messages/pl';

const messages = pl.serviceVendorForm;

export const serviceVendorSchema = z.object({
  name: safeTextSchema(messages.nameLabel, { max: 200, requiredMessage: messages.nameRequired }),
  street: safeTextSchema(messages.streetLabel, { max: 200, requiredMessage: messages.streetRequired }),
  city: safeTextSchema(messages.cityLabel, { max: 100, requiredMessage: messages.cityRequired }),
  postalCode: z
    .string()
    .min(1, messages.postalCodeRequired)
    .regex(/^\d{2}-\d{3}$/, messages.postalCodeInvalid),
  phone: phoneSchema(),
  email: z.string().min(1, messages.emailRequired).email(messages.emailInvalid),
  website: z
    .string()
    .optional()
    .refine((val) => !val || val === '' || /^https?:\/\/.+/.test(val), messages.websiteInvalid),
  description: safeTextSchema(messages.descriptionLabel, { max: 1000, multiline: true, required: false }).optional(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
});

export const createServiceVendorSchema = serviceVendorSchema.extend({
  serviceTypeId: z.string().min(1, messages.serviceTypeRequired),
  acceptsTerms: z.boolean().refine((val) => val === true, messages.termsRequired),
  acceptsRepresentation: z.boolean().refine((val) => val === true, messages.representationRequired),
  acceptsMarketing: z.boolean(),
});

export type ServiceVendorFormData = z.infer<typeof serviceVendorSchema>;
export type CreateServiceVendorFormData = z.infer<typeof createServiceVendorSchema>;
